<div style="padding: 12px; height: 100%;">
    <app-mouvement-stock-datagrid
      [configFiltre]="configFiltre"
      [currentPartenaireId]="currentPartenaireId"
    ></app-mouvement-stock-datagrid>
</div>
